import { render, staticRenderFns } from "./OrgItems.vue?vue&type=template&id=3f9d78b5&scoped=true&"
import script from "./OrgItems.vue?vue&type=script&lang=js&"
export * from "./OrgItems.vue?vue&type=script&lang=js&"
import style0 from "./OrgItems.vue?vue&type=style&index=0&id=3f9d78b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d78b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f9d78b5')) {
      api.createRecord('3f9d78b5', component.options)
    } else {
      api.reload('3f9d78b5', component.options)
    }
    module.hot.accept("./OrgItems.vue?vue&type=template&id=3f9d78b5&scoped=true&", function () {
      api.rerender('3f9d78b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/OrgItems.vue"
export default component.exports